import script from "./WorkspaceShell.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceShell.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceShell.vue?vue&type=style&index=0&id=4ac0a280&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ac0a280"]])

export default __exports__